"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateJobChecklistItemRequestSchema = exports.createJobChecklistRequestSchema = exports.jobChecklistCompletionSchema = exports.jobChecklistSchema = exports.jobChecklistProgressSchema = exports.jobChecklistItemSchema = exports.jobChecklistItemTypeSchema = exports.jobChecklistItemIdSchema = exports.jobChecklistIdSchema = void 0;
const zod_1 = require("zod");
exports.jobChecklistIdSchema = zod_1.z.string().uuid();
exports.jobChecklistItemIdSchema = zod_1.z.string().uuid();
exports.jobChecklistItemTypeSchema = zod_1.z.enum([
    "CHECKBOX",
    "TEXT",
    "NUMBER",
]);
const checklistItemBaseSchema = zod_1.z.object({
    id: exports.jobChecklistItemIdSchema,
    label: zod_1.z.string(),
    required: zod_1.z.boolean(),
    position: zod_1.z.number().int().nonnegative(),
    completedAt: zod_1.z.string().datetime().nullable(),
    completedByMembershipId: zod_1.z.string().uuid().nullable(),
});
exports.jobChecklistItemSchema = zod_1.z.discriminatedUnion("type", [
    checklistItemBaseSchema.extend({
        type: zod_1.z.literal("CHECKBOX"),
        value: zod_1.z.boolean(),
    }),
    checklistItemBaseSchema.extend({
        type: zod_1.z.literal("TEXT"),
        value: zod_1.z.string().nullable(),
    }),
    checklistItemBaseSchema.extend({
        type: zod_1.z.literal("NUMBER"),
        value: zod_1.z.number().finite().nullable(),
    }),
]);
exports.jobChecklistProgressSchema = zod_1.z.object({
    completedItems: zod_1.z.number().int().nonnegative(),
    totalItems: zod_1.z.number().int().nonnegative(),
});
exports.jobChecklistSchema = zod_1.z.object({
    id: exports.jobChecklistIdSchema,
    title: zod_1.z.string(),
    position: zod_1.z.number().int().nonnegative(),
    progress: exports.jobChecklistProgressSchema,
    items: zod_1.z.array(exports.jobChecklistItemSchema),
});
exports.jobChecklistCompletionSchema = zod_1.z.object({
    canComplete: zod_1.z.boolean(),
    completedRequiredItems: zod_1.z.number().int().nonnegative(),
    requiredItems: zod_1.z.number().int().nonnegative(),
    incompleteRequiredItemIds: zod_1.z.array(exports.jobChecklistItemIdSchema),
});
exports.createJobChecklistRequestSchema = zod_1.z.object({
    title: zod_1.z.string().trim().min(2).max(160),
    items: zod_1.z
        .array(zod_1.z.object({
        label: zod_1.z.string().trim().min(2).max(240),
        type: exports.jobChecklistItemTypeSchema,
        required: zod_1.z.boolean().default(false),
    }))
        .min(1)
        .max(50),
});
exports.updateJobChecklistItemRequestSchema = zod_1.z.discriminatedUnion("type", [
    zod_1.z.object({ type: zod_1.z.literal("CHECKBOX"), value: zod_1.z.boolean() }),
    zod_1.z.object({
        type: zod_1.z.literal("TEXT"),
        value: zod_1.z.string().trim().max(5_000).nullable(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal("NUMBER"),
        value: zod_1.z
            .number()
            .finite()
            .min(-1_000_000_000)
            .max(1_000_000_000)
            .nullable(),
    }),
]);
//# sourceMappingURL=job-checklist.js.map